import { get } from '@/utils/http';

export const getSocialNewtworks = () => {
    return get('social-networks');
}